import { PagedSearch } from 'src/app/shared';

export class FormResponseSearchDto extends PagedSearch {
  FormId: number;
  SubmissionDateStart: Date;
  SubmissionDateEnd: Date;
  ProfileName: string;
  DateCreated: Date;

  constructor() {
    super();

    const today = new Date();
    this.SubmissionDateStart = new Date();
    this.SubmissionDateStart.setFullYear(today.getFullYear() - 1);
    this.SubmissionDateEnd = new Date();
    this.SubmissionDateEnd.setDate(today.getDate() + 1);
  }
}
